<script lang="ts" setup>
    import type { StampedWidgetData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    const props = defineProps<IWidgetProps<StampedWidgetData>>();

    const { data } = useWidget(props);
    const { isUS } = useLocales();

    onMounted(async () => {
        if (isUS.value) {
            await stampedInit();
            await wait(1000);
            throttledReloadUGC();
        }
    });
</script>
<template>
    <client-only>
        <mol-section class="cms-stamped-widget">
            <div class="col-span-12">
                <div class="overflow-hidden">
                    <renderer-html :content="data.code" />
                </div>
            </div>
        </mol-section>
    </client-only>
</template>
